import React, {useEffect, useState} from "react";
import {Typography} from "@material-tailwind/react";
import persianNumberFormat from "../../helper/PersianNumberFormat";

const ReferredList = ({referreds}) => {

  const [referredList, setReferredList] = useState(referreds?.length > 0 ? referreds : null);


  useEffect(() => {
    setReferredList(referreds)
  }, [referreds]);

  return (
    <>
      {referredList && referredList.length > 0 &&
        referredList.map(({full_name, phone, created_at}, index) => (
          <div
            key={index}
            className="flex flex-col w-full pb-3 pt-3 border-b-2 last:pb-0"
          >
            <div className="flex flex-row w-full justify-between">
              <div className="flex flex-col">
                <Typography color="blue-gray" variant="h6">
                  {`${persianNumberFormat(index + 1)} - ${full_name}`}
                </Typography>
              </div>
              <div className="flex flex-col">
                <Typography variant="small" color="blue-gray">
                  {persianNumberFormat(`${phone.slice(-2)}***${phone.slice(0, 6)}`)}
                </Typography>
              </div>
            </ div>
            <div className="flex flex-row w-full justify-end">
              <div className="flex flex-col">
                <Typography color="blue-gray" variant="paragraph">
                  {`${persianNumberFormat(created_at.split(" ")[1])} ${persianNumberFormat(created_at.split(" ")[0])}`}
                </Typography>
              </div>
            </div>


          </div>
        ))}
      {referredList && referredList.length === 0 &&
        <>
          <Typography color="gray" className="textCenter">
            رزرو فعالی ندارید
          </Typography>
        </>

      }
    </>
  );
};

export default ReferredList;
